import { c as _c } from "react/compiler-runtime";
import { DataFileInterface } from '@systemeio/file-manager';
import { DownloadIcon } from '@systemeio/ui/icons';
import { Tooltip } from '@systemeio/ui';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { BinIcon, CheckCircleIcon } from '@systemeio/ui/icons';
export type FileListItemType = {
  file: Pick<DataFileInterface, 'id' | 'name' | 'filename' | 'path'>;
  progress?: number;
  disabled?: boolean;
  uploaded?: boolean;
};
export const FileListItem = t0 => {
  const $ = _c(39);
  const {
    file,
    progress,
    disabled,
    uploaded,
    onDelete
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== progress) {
    t1 = progress !== undefined && <span className="text-text-tertiary text-sm">{progress}%</span>;
    $[0] = progress;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== uploaded) {
    t2 = uploaded && <CheckCircleIcon className="fill-green h-[16px] w-[16px]" />;
    $[2] = uploaded;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = file.name;
  let t4;
  if ($[4] !== t) {
    t4 = t("global.download");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = file.path;
  const t6 = disabled ? "cursor-default" : "group-hover:fill-brand-primary group-focus-visible:fill-brand-primary";
  let t7;
  if ($[6] !== t6) {
    t7 = twMerge("main-transition-colors h-[16px] w-[16px]", t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t7) {
    t8 = <DownloadIcon className={t7} />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== file.path || $[11] !== t8) {
    t9 = <a target="_blank" rel="noreferrer" href={t5} className="group outline-hidden">{t8}</a>;
    $[10] = file.path;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== disabled || $[14] !== t4 || $[15] !== t9) {
    t10 = <Tooltip className="shrink-0" wrapperClassName="h-[16px] w-[16px] self-center" mode="hover" label={t4} disabled={disabled}>{t9}</Tooltip>;
    $[13] = disabled;
    $[14] = t4;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t("global.delete");
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== onDelete) {
    t12 = () => onDelete();
    $[19] = onDelete;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = disabled ? "cursor-default" : "group-hover:fill-danger group-focus-visible:fill-danger ";
  let t14;
  if ($[21] !== t13) {
    t14 = twMerge(t13);
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = `
                main-transition-colors h-[16px] w-[16px]
                ${t14}`;
  let t16;
  if ($[23] !== t15) {
    t16 = <BinIcon className={t15} />;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== disabled || $[26] !== t12 || $[27] !== t16) {
    t17 = <button disabled={disabled} onClick={t12} className="group outline-hidden">{t16}</button>;
    $[25] = disabled;
    $[26] = t12;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== disabled || $[30] !== t11 || $[31] !== t17) {
    t18 = <Tooltip className="shrink-0" wrapperClassName="h-[16px] w-[16px] self-center" mode="hover" label={t11} disabled={disabled}>{t17}</Tooltip>;
    $[29] = disabled;
    $[30] = t11;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== file.name || $[34] !== t1 || $[35] !== t10 || $[36] !== t18 || $[37] !== t2) {
    t19 = <div className="flex flex-row gap-2 break-all">{t1}{t2}{t3}{t10}{t18}</div>;
    $[33] = file.name;
    $[34] = t1;
    $[35] = t10;
    $[36] = t18;
    $[37] = t2;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  return t19;
};